var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.48.449a1.249 1.249 0 00-1.747.265l-5.924 8.04L2.042 5.74A1.251 1.251 0 00.479 7.693l4.783 3.826a1.263 1.263 0 001.787-.235l6.7-9.087A1.25 1.25 0 0013.48.449z"
  })));
}
export default SvgCheckmark;